import { render } from "./helpView.vue?vue&type=template&id=08059b6e"
import script from "./helpView.vue?vue&type=script&lang=js"
export * from "./helpView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__